import {connect} from 'react-redux';
import {denormalize} from 'normalizr';

import {schema} from '../../../../../state/schema';
import {loadResourceTags, deleteResourceTag} from '../../../../../state/modules/resourceTags/actions';
import {sendMessage} from '../../../../../state/actions';
import ResourceTagsList from '../components/ResourceTagsList';

const mapStateToProps = (state, ownProps) => {

  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.resourceTags.getIn(['pages', order, limit, page]);

  return {
    list: result 
      ? result.map(x => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['resourceTags', x]),
              schema.resourceTag,
              state.entities.toJS()
            )
          };
        }).toArray()
      : [],
    isLoading: state.resourceTags.get('isLoading'),
    total: state.resourceTags.get('total'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    load: (page, limit, order, filter, cb) => {
      dispatch(loadResourceTags(page, limit, order, filter, cb));
    },
    remove: (id, cb) => {
      dispatch(deleteResourceTag(id, cb));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  }
}

const ResourceTagsListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ResourceTagsList);

export default ResourceTagsListContainer;
